// Success alert messages
export const GENERIC_SUCCESS_TITLE = "Success";
export const GENERIC_SUCCESS_MESSAGE = "Your request has been processed successfully.";

export const LOGIN_SUCCESS_MESSAGE = "You have successfully logged in.";

// Failed form messages
export const E_ENTER_EMAIL_ADDRESS = "Please enter a valid email address.";
export const E_ENTER_PASSWORD = "Please enter your password.";
export const E_CONFIRM_PASSWORD = "Please confirm your password.";
export const E_PASSWORD_NOT_MATCHED = "Password not matched.";
export const E_REQUIRED_FIRST_NAME = "First name is required";
export const E_REQUIRED_LAST_NAME = "Last name is required";
export const E_REQUIRED_BIRTHDATE = "Birth date is required";

// Failed alert messages
export const E_GENERIC_TITLE = "Failed";
export const E_GENERIC_MESSAGE = "An error occurred while processing your request. Please try again later.";
export const E_MULTIPLE_LOGIN_DETECTED = "Multiple logins were detected. Our system has detected that your account is logged in to another device with different IP address.";
export const E_MULTIPLE_LOGIN_DETECTED_SUB = "Note that sharing of online review access is strictly prohibited and subject to penalties. It may result in the termination of your account. The status of your account will be further investigated and reviewed by our team.";
export const E_ACCOUNT_DEACTIVATED = "Your account has been deactivated.";
export const E_CANNOT_MARK_AS_WATCHED = "This video is a trial and cannot be marked.";
export const E_NO_VIDEOS_FOUND = "No videos found.";

// Form/Label/Button Names
export const GENERIC_FORM_SUBMIT = 'Submit';
export const CREATE_ACCOUNT = "Create Account";
export const SIGN_IN = "Sign In";
export const COMPLETE_PROFILE = "Complete Profile";
export const FORGOT_PASSWORD = "Forgot Password";
export const REGISTRATION = "Create Account";
export const RESET_PASSWORD = "Enter New Password";
export const BANNER_LABEL1 = "You got this";
export const BANNER_LABEL2 = "Stay motivated";
export const CHOOSE_SCHOOL = "Choose your school";
export const CHOOSE_PROGRAM = "Choose your program";
export const BTN_BACK_TO_LOGIN = "GO BACK";
export const BTN_CREATE = "CREATE";
export const BTN_CONFIRM = "CONFIRM";
export const BTN_DONE = "DONE";
export const BTN_EDIT = "EDIT";
export const BTN_UPDATE = "UPDATE";
export const BTN_ACCEPT_AND_CONTINUE = "ACCEPT & CONTINUE";
export const FORM_FORGOT_PASSWORD_DESCRIPTION = "Enter your email address to request for a new password.";

// Settings sub menu
export const SETTINGS_PROFILE = "Profile";
export const SETTINGS_CHANGE_PASSWORD = "Change Password";
export const SETTINGS_TERMS_AND_CONDITIONS = "Terms and Conditions";

// External URLs
export const APP_LOGO_URL = "https://sgp1.digitaloceanspaces.com/pinnacleassets/assets/2025-06-29-1751202848539.svg";
export const APP_LOGO_WHITE_URL = "https://sgp1.digitaloceanspaces.com/pinnacleassets/webapp-assets/2025-08-27-1756298900684.svg";
export const APP_BANNER_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/assets/2025-06-29-1751203071277.png";
export const APP_SEARCH_BANNER_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/assets/2025-07-03-1751525865073.png";
export const SELECT_VIDEO_PLAYER_HALF_BG = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-08-24-1756042717188.svg";
export const SELECT_VIDEO_PLAYER_FULL_BG = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-08-24-1756045400140.svg";

// Logout
export const SUCCESSFULLY_LOGGED_OUT_MSG = "You have successfully logged out.";
export const CONFIRM_LOGOUT_MSG = "Are you sure you want to log out?";

// storage key
export const STORAGE_KEY = "pinnacleStreamingV3AccessToken";